<p-dialog
  [(visible)]="deleteDialogVisible"
  [modal]="true"
  [closable]="!deleteInProgress"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!deleteInProgress"
  [style]="{ width: 'min(420px, 94vw)' }"
  styleClass="med-delete-dialog"
  (onHide)="onDeleteDialogHide()"
>
  <ng-template pTemplate="header">
    <div class="med-delete-head">
      <div class="med-delete-head__icon" aria-hidden="true">
        <i class="pi pi-trash"></i>
      </div>
      <div>
        <h3 class="med-delete-head__title">Delete medicine</h3>
        <p class="med-delete-head__subtitle">This action removes it from the master list</p>
      </div>
    </div>
  </ng-template>

  <div class="med-delete-body" *ngIf="medicineToDelete as target">
    <p class="med-delete-lead">
      Are you sure you want to delete
      <strong>{{ target.name }}</strong>?
    </p>

    <div class="med-delete-meta">
      <span class="med-delete-meta__chip" *ngIf="target.potency">
        <i class="pi pi-flask"></i>
        {{ target.potency }}
      </span>
      <span class="med-delete-meta__chip med-delete-meta__chip--code" *ngIf="target.code">
        <i class="pi pi-hashtag"></i>
        {{ target.code }}
      </span>
    </div>

    <div class="med-delete-note">
      <i class="pi pi-info-circle"></i>
      <span>The medicine code may become available for new entries after deletion.</span>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="med-delete-footer">
      <button
        type="button"
        class="med-btn med-btn--ghost"
        [disabled]="deleteInProgress"
        (click)="closeDeleteDialog()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="med-btn med-btn--danger"
        [disabled]="deleteInProgress"
        (click)="confirmDeleteMedicine()"
      >
        <i class="pi" [ngClass]="deleteInProgress ? 'pi-spin pi-spinner' : 'pi-trash'"></i>
        {{ deleteInProgress ? 'Deleting...' : 'Delete medicine' }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-md-12 mb-3">
      <div class="medicine-toolbar">
        <div class="toolbar-row">
          <h5 class="toolbar-title mb-0">Medicine Master</h5>
          <div class="toolbar-stats">
            <span class="count-chip">Total: {{ totalCount }}</span>
            <span class="count-chip count-chip-active">Showing: {{ filteredCount }}</span>
          </div>
        </div>

        <div class="toolbar-row toolbar-controls">
          <div class="search-wrap">
            <i class="pi pi-search search-icon"></i>
            <input
              type="text"
              class="form-control search-input"
              [(ngModel)]="searchTerm"
              (input)="applyFilter()"
              placeholder="Search medicine, potency or code"
            />
            <button
              *ngIf="searchTerm"
              type="button"
              class="clear-search-btn"
              (click)="clearSearch()"
              pTooltip="Clear search"
              tooltipPosition="top"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>

          <button
            pButton
            type="button"
            label="Create Medicine"
            icon="pi pi-plus"
            class="aesthetic-btn"
            (click)="openDialog()"
          ></button>
          <button
            pButton
            type="button"
            label="Reset"
            icon="pi pi-filter-slash"
            class="reset-btn"
            (click)="clearFilters()"
          ></button>
        </div>

        <div class="alphabet-strip-wrap">
          <div class="alphabet-strip">
            <button
              *ngFor="let letter of letters"
              type="button"
              class="alphabet-chip"
              [ngClass]="{ active: selectedLetter === letter }"
              (click)="selectLetter(letter)"
            >
              {{ letter }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Medicines Table -->
    <div class="col-md-12">
      <div class="table-context mb-2">
        <span class="table-context-label">Letter Filter:</span>
        <span class="table-context-value">{{ selectedLetter }}</span>
      </div>

      <!-- PrimeNG Table -->
      <p-table
        #dt
        [value]="filteredMedicines"
        [paginator]="true"
        [rows]="10"
        [globalFilterFields]="['name', 'potency', 'code']"
        [rowsPerPageOptions]="[10, 20, 50]"
        sortMode="multiple"
        [rowHover]="true"
        styleClass="p-datatable-gridlines"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name"><b>Medicine</b> <p-sortIcon field="name"></p-sortIcon></th>
            <th pSortableColumn="potency"><b>Potency</b> <p-sortIcon field="potency"></p-sortIcon></th>
            <th pSortableColumn="code"><b>Code</b> <p-sortIcon field="code"></p-sortIcon></th>
            <th style="width: 8rem"><b>Actions</b></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-med>
          <tr>
            <td>
              <span class="medicine-name">{{ med.name }}</span>
            </td>
            <td>
              <span class="pill potency-pill">{{ med.potency }}</span>
            </td>
            <td>
              <span class="pill code-pill">{{ med.code }}</span>
            </td>
            <td class="text-center">
              <button
                pButton
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success p-button-text row-action-btn me-2"
                (click)="handleEvent({ action: { tooltip: 'Update Medicine' }, data: med })"
                pTooltip="Update Medicine"
                tooltipPosition="top"
              ></button>
              <button
                pButton
                icon="pi pi-trash"
                class="p-button-rounded p-button-danger p-button-text row-action-btn"
                (click)="handleEvent({ action: { tooltip: 'Delete Medicine' }, data: med })"
                pTooltip="Delete Medicine"
                tooltipPosition="top"
              ></button>
            </td>
          </tr>
        </ng-template>

        <!-- Empty Message -->
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="4" class="text-center">No medicines found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- Create/Edit Medicine Dialog -->
  <p-dialog
    [(visible)]="displayDialog"
    [modal]="true"
    [style]="{ width: 'min(94vw, 620px)' }"
    [contentStyle]="{ padding: '0', overflow: 'hidden' }"
    [draggable]="false"
    [resizable]="false"
    [baseZIndex]="10000"
    styleClass="med-dialog"
    (onHide)="closeForm()"
  >
    <ng-template pTemplate="header">
      <div class="med-dialog-head">
        <div class="med-dialog-head__icon">
          <i class="pi" [ngClass]="medicine.id ? 'pi-pencil' : 'pi-plus'"></i>
        </div>
        <h2 class="med-dialog-head__title">{{ medicine.id ? 'Update Medicine' : 'Create Medicine' }}</h2>
      </div>
    </ng-template>

    <div class="med-dialog-body">
      <section class="med-section">
        <div class="med-field">
          <label for="medName">Medicine name <span class="med-required">*</span></label>
          <input
            id="medName"
            type="text"
            pInputText
            class="med-input"
            [ngModel]="medicine.name"
            (ngModelChange)="onMedicineNameChange($event)"
            placeholder="e.g. Arnica Montana"
          />
        </div>
      </section>

      <section class="med-section">
        <div class="med-field med-field--tight">
          <label>Potency scale <span class="med-required">*</span></label>
          <div class="med-scale-grid">
          <button
            type="button"
            *ngFor="let scale of potencyScales"
            class="med-scale-card"
            [class.active]="selectedScale === scale.value"
            (click)="selectPotencyScale(scale.value)"
          >
            <span class="med-scale-card__label">{{ scale.label }}</span>
            <span class="med-scale-card__hint">{{ getPotencyScaleHint(scale.value) }}</span>
          </button>
          </div>
        </div>

        <div class="med-quick-potencies" *ngIf="!medicine.id && !selectedScale">
          <span class="med-quick-label">Common:</span>
          <button
            type="button"
            class="med-quick-chip"
            *ngFor="let potency of commonPotencies"
            (click)="selectQuickPotency(potency)"
          >
            {{ potency }}
          </button>
        </div>

        <div class="med-field" *ngIf="selectedScale">
          <label for="potency">Select potency <span class="med-required">*</span></label>
          <p-dropdown
            id="potency"
            styleClass="med-dropdown"
            [options]="availablePotencies"
            [(ngModel)]="medicine.potency"
            (ngModelChange)="onPotencyChange($event)"
            placeholder="Choose potency"
            [filter]="availablePotencies.length > 8"
            [showClear]="true"
            appendTo="body"
          ></p-dropdown>
        </div>
      </section>

      <section class="med-section med-section--code">
        <div class="med-code-panel" *ngIf="isCreateMode; else editCodeBlock">
          <div class="med-code-strip">
            <span class="med-code-strip__badge"><i class="pi pi-sparkles"></i> Suggested</span>

            <div class="med-code-strip__flow" *ngIf="codeSuggestion?.suggested_code; else codePendingTpl">
              <ng-container *ngIf="codeSuggestion?.last_code">
                <span class="med-code-strip__last">{{ codeSuggestion?.last_code }}</span>
                <span class="med-code-strip__arrow" aria-hidden="true">→</span>
              </ng-container>
              <span class="med-code-strip__next">{{ codeSuggestion?.suggested_code }}</span>
            </div>

            <ng-template #codePendingTpl>
              <div class="med-code-strip__flow">
                <span class="med-code-strip__pending" *ngIf="codeSuggestionPending">—</span>
                <span class="med-code-strip__loading" *ngIf="!codeSuggestionPending">
                  <i class="pi pi-spin pi-spinner"></i>
                </span>
              </div>
            </ng-template>

            <span class="med-code-strip__scale" *ngIf="codeSuggestion?.suggested_code || codeSuggestionPending">
              {{ codeSuggestionScaleLabel }}
            </span>

            <button
              type="button"
              class="med-code-apply"
              *ngIf="codeSuggestion?.suggested_code && !codeMatchesSuggestion"
              (click)="applySuggestedCode()"
            >
              Use suggested
            </button>
          </div>

          <div class="med-field med-field--compact">
            <label for="code">Code <span class="med-required">*</span></label>
            <input
              id="code"
              type="text"
              pInputText
              class="med-input med-input--code"
              maxlength="12"
              [ngModel]="medicine.code"
              (ngModelChange)="onCodeInputChange($event)"
              [class.is-match]="codeMatchesSuggestion"
              [class.is-warn]="codeManuallyEdited && !codeMatchesSuggestion"
              placeholder="Auto-filled from name"
            />
            <div class="med-code-status is-ok" *ngIf="codeMatchesSuggestion">
              <i class="pi pi-check-circle"></i> Matches the next available code
            </div>
            <div class="med-code-status is-warn" *ngIf="codeManuallyEdited && !codeMatchesSuggestion">
              <i class="pi pi-exclamation-triangle"></i> Custom code — verify it is unique
            </div>
            <div class="med-code-status is-error" *ngIf="codeError">
              <i class="pi pi-times-circle"></i> This code is already in use
            </div>
          </div>
        </div>

        <ng-template #editCodeBlock>
          <div class="med-field">
            <label for="codeEdit">Code <span class="med-required">*</span></label>
            <input
              id="codeEdit"
              type="text"
              pInputText
              class="med-input med-input--code"
              maxlength="12"
              [ngModel]="medicine.code"
              (ngModelChange)="onCodeInputChange($event)"
              placeholder="Medicine code"
            />
            <div class="med-code-status is-error" *ngIf="codeError">
              <i class="pi pi-times-circle"></i> This code is already in use
            </div>
          </div>
        </ng-template>
      </section>
    </div>

    <ng-template pTemplate="footer">
      <div class="med-dialog-footer">
        <button type="button" class="med-btn med-btn--ghost" (click)="closeForm()">
          Cancel
        </button>
        <button type="button" class="med-btn med-btn--primary" (click)="processMedicine()">
          <i class="pi" [ngClass]="medicine.id ? 'pi-save' : 'pi-plus'"></i>
          {{ medicine.id ? 'Save changes' : 'Add medicine' }}
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>
